import { Component, OnInit } from '@angular/core';
import { ConfirmationService } from 'primeng/api';
import { LoginService } from '../../../services/login.service';
import { ToastService } from '../../../services/toast.service';
import { Usuario } from '../../../types/Usuario.type';
import { UsuarioService } from '../clientes/usuarios/usuario.service';

@Component({
  selector: 'app-usuarios',
  templateUrl: './usuarios.component.html',
  styleUrl: './usuarios.component.css',
    providers: [ConfirmationService]
})
export class UsuariosComponent implements OnInit {
  usuarios: Usuario[] = [];
  usuarioSelecionado: Usuario = {} as Usuario;

  abreUsuarioDialog: boolean = false;
  usuariosClones: { [s: string]: Usuario } = {};

  constructor(
    private usuarioService: UsuarioService,
    private toastService: ToastService,
    private confirmationService: ConfirmationService, 
    private loginService: LoginService
  ) {}

  ngOnInit(): void {
    this.carregaUsuarios();
  }

  carregaUsuarios() {
    this.usuarioService.getAll().subscribe((usuarios) => {
      this.usuarios = usuarios;
    });
  }

  abreUsuario(usuario: any) {
    this.usuarioSelecionado = usuario;
    this.abreUsuarioDialog = true;
  }

  escondeUsuarioDialog() {
    this.abreUsuarioDialog = false;
    this.carregaUsuarios();
  }

  editarUsuario(usuario: Usuario) {
    this.usuariosClones[usuario.id as string] = { ...usuario };
  }

  atualizarUsuario(usuario: Usuario) {
    this.usuarioService.put(usuario).subscribe({
      next: () => {
        this.toastService.sucesso('Sucesso', 'Usuário salvo com sucesso');
      },
      error: (value) => {
        this.toastService.erro(
          'Erro',
          'Erro ao salvar o usuário, tente novamente: ' + value.error
        );
      },
    });
  }

  cancelarUsuario(usuario: Usuario) {
    delete this.usuariosClones[usuario.id as string];
  }

  desativarUsuario(usuario: Usuario) {
    this.usuarioService.delete(usuario.id).subscribe({
      next: () => {
        this.toastService.sucesso('Sucesso', 'Usuário desativado');
        this.carregaUsuarios();
      },
      error: (error) => {
        this.toastService.erro('Erro', 'Erro ao desativar: ' + error);
      },
      complete: () => {},
    });
  }

  ativarUsuario(usuario: Usuario) {
    this.usuarioService.ativar(usuario.id).subscribe({
      next: () => {
        this.toastService.sucesso('Sucesso', 'Usuário ativado');
        this.carregaUsuarios();
      },
      error: (error) => {
        this.toastService.erro('Erro', 'Erro ao ativar: ' + error);
      },
      complete: () => {},
    });
  }

  redefinirSenha(usuario: Usuario, event: Event) {

    this.confirmationService.confirm({
      target: event.target as EventTarget,
      message: 'Tem certeza que deseja reiniciar a senha? A operação não pode ser desfeita ',
      header: 'Confirmar',
      icon: 'pi pi-exclamation-triangle',
      acceptIcon:"none",
      rejectIcon:"none",
      rejectButtonStyleClass:"p-button-text",
      acceptLabel: "Redefinir",
      rejectLabel: "Cancelar",
      accept: () => {
        this.loginService.solicitacaoRedefinicao(usuario.email).subscribe(() => {
          this.toastService.sucesso("Sucesso", "A redefinição foi solicitada. Foi enviado ao e-mail cadastrado no usuário");
            console.log("realizado")
        })
      },
      
    });

  }
}
